import { useEffect, useRef, useState } from "react";
import { LuMic } from "react-icons/lu";

/**
 * Voice search (rulebook §2 rule 8) — Web Speech API, hi-IN pehle (mandi ki
 * bhasha), phir en-IN. Browser support na ho to button dikhta hi nahi.
 * Bola hua text `onResult` me aata hai; search chalana parent ka kaam.
 */
const getRecognition = (): any => {
  const w = window as any;
  return w.SpeechRecognition || w.webkitSpeechRecognition || null;
};

const MicButton = ({
  onResult,
  className = "",
  size = 18,
}: {
  onResult: (text: string) => void;
  className?: string;
  size?: number;
}) => {
  const [supported, setSupported] = useState(false);
  const [listening, setListening] = useState(false);
  const recRef = useRef<any>(null);

  useEffect(() => {
    setSupported(!!getRecognition());
    return () => {
      try {
        recRef.current?.stop();
      } catch (e) {
        // ignore
      }
    };
  }, []);

  if (!supported) return null;

  const start = () => {
    const Rec = getRecognition();
    if (!Rec) return;
    if (listening) {
      try {
        recRef.current?.stop();
      } catch (e) {
        // ignore
      }
      setListening(false);
      return;
    }
    const rec = new Rec();
    recRef.current = rec;
    rec.lang = "hi-IN";
    rec.interimResults = false;
    rec.maxAlternatives = 1;
    rec.onresult = (ev: any) => {
      const text = ev?.results?.[0]?.[0]?.transcript;
      if (text) onResult(String(text).trim());
    };
    rec.onend = () => setListening(false);
    rec.onerror = () => setListening(false);
    try {
      rec.start();
      setListening(true);
    } catch (e) {
      setListening(false);
    }
  };

  return (
    <button
      type="button"
      aria-label={listening ? "Sun raha hoon…" : "Bol kar search karein"}
      title={listening ? "Sun raha hoon…" : "Bol kar search karein"}
      onClick={start}
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition ${
        listening ? "animate-pulse bg-ci-orange text-white" : "text-ci-muted hover:bg-ci-bg hover:text-ci-navy"
      } ${className}`}
    >
      <LuMic size={size} />
    </button>
  );
};

export default MicButton;
